import React from "react";
import { typography, textColors, borders, surfaces, interactive } from "../../../design-system/tokens";
import InfoIcon from "../InfoIcon";

const LINE_GAPS = {
  "leading-none": 1.5,
  "leading-tight": 3,
  "leading-snug": 4.5,
  "leading-normal": 6,
  "leading-relaxed": 7.5,
  "leading-loose": 9,
};

const READABLE_NAMES = {
  "leading-none": "None",
  "leading-tight": "Tight",
  "leading-snug": "Snug",
  "leading-normal": "Normal",
  "leading-relaxed": "Relaxed",
  "leading-loose": "Loose",
};

function LineHeightIcon({ trackingValue, selected }) {
  const gap = LINE_GAPS[trackingValue] || 5;
  const barH = 2;
  const centerY = 11;
  const topY = centerY - barH - gap;
  const bottomY = centerY + barH + gap;
  const color = selected ? "white" : "currentColor";

  return (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true">
      <rect x="4" y={topY} width="16" height={barH} rx="1" fill={color} />
      <rect x="4" y={centerY} width="16" height={barH} rx="1" fill={color} />
      <rect x="4" y={bottomY} width="16" height={barH} rx="1" fill={color} />
    </svg>
  );
}

function HeightChip({ value, label, selected, onSelect }) {
  return (
    <button
      type="button"
      onClick={() => onSelect(value)}
      className={`w-9 h-9 flex items-center justify-center border rounded-lg transition-all ${
        selected
          ? `${interactive.selectedBg} text-white ${interactive.selectedBorder} shadow-sm`
          : `${borders.default} ${surfaces.tertiary} ${textColors.primary} ${surfaces.hover}`
      }`}
      aria-pressed={selected}
      title={`${READABLE_NAMES[value] || label} (${label})`}
    >
      <LineHeightIcon trackingValue={value} selected={selected} />
    </button>
  );
}

export default function LineHeightField({ label, help, value, onChange, choices, infoText }) {
  const normalized = (choices || []).map((c) => ({ value: c.value, label: c.label }));

  return (
    <div className="field-wrapper">
      <div className="flex flex-wrap items-center gap-2">
        <label className={`mr-1 whitespace-nowrap ${typography.label} ${textColors.secondary}`}>
          {label}
          {infoText ? <span className="ml-1.5"><InfoIcon text={infoText} /></span> : null}
        </label>
        <div className="flex flex-wrap items-center gap-1.5">
          {normalized.map((c) => (
            <HeightChip
              key={c.value}
              value={c.value}
              label={c.label}
              selected={value === c.value}
              onSelect={(val) => onChange(val)}
            />
          ))}
        </div>
      </div>
      {help && <div className={`mt-1 ${typography.caption} ${textColors.tertiary}`}>{help}</div>}
    </div>
  );
}
